var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.305 10.969a.662.662 0 000-.899l-3.75-3.75a.662.662 0 00-.899 0 .662.662 0 000 .899l2.696 2.656H5.625A.642.642 0 005 10.5c0 .352.273.625.625.625h14.727l-2.696 2.695a.662.662 0 000 .899.662.662 0 00.899 0l3.75-3.75zM8.906 24.719a.662.662 0 00.899 0 .662.662 0 000-.899l-2.696-2.695h14.766a.642.642 0 00.625-.625c0-.313-.313-.625-.625-.625H7.109l2.696-2.656a.662.662 0 000-.899.662.662 0 00-.899 0l-3.75 3.75a.662.662 0 000 .899l3.75 3.75z",
    fill: "#2EA7FF"
  })));
}
export default SvgSwap;